import { render, staticRenderFns } from "./PageAccessOnboardingPassword.vue?vue&type=template&id=2b33805f&scoped=true&"
import script from "./PageAccessOnboardingPassword.vue?vue&type=script&lang=js&"
export * from "./PageAccessOnboardingPassword.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessOnboardingPassword.vue?vue&type=style&index=0&id=2b33805f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33805f",
  null
  
)

export default component.exports